<div class="wrapper">
  <div class="terms-and-conditions">
    <h2 class="terms-and-conditions__title">
      {{ 'signUpPage.termsAndConditions.title' | translate }}
    </h2>
    <p class="terms-and-conditions__subtitle">
      {{ 'signUpPage.termsAndConditions.subtitle' | translate }}
    </p>
    <div class="terms-and-conditions__scroll-wrapper">
      <div class="terms-and-conditions__content">
        <div class="terms-and-conditions__date">
          {{ 'signUpPage.termsAndConditions.content.date' | translate }}
        </div>
        <div class="terms-and-conditions__descr">
          {{ 'signUpPage.termsAndConditions.content.description' | translate }}
        </div>
        <div class="terms-and-conditions__conditions">
          @for (condition of conditions; track condition) {
            <div
              class="terms-and-conditions__label"
              [innerHTML]="condition.label | translate"
            ></div>
            <div
              class="terms-and-conditions__description"
              [innerHTML]="condition.description | translate"
            ></div>
          }
        </div>
      </div>
    </div>
    <div class="terms-and-conditions__wrapper-btn">
      <button class="terms-and-conditions__cancel" (click)="closeModal(false)">
        {{ 'signUpPage.termsAndConditions.cancelButton' | translate }}
      </button>
      <button class="terms-and-conditions__agree btn-primary" (click)="closeModal(true)">
        {{ 'signUpPage.termsAndConditions.agreeButton' | translate }}
      </button>
    </div>
  </div>
</div>
